import TermsOfSalesComponent from "@/components/terms/TermsOfSalesComponent.vue";
import BackgroundVideo from "@/components/default/BackgroundVideo.vue";
export default {
  name: "TermsOfSales",
  components: {
    TermsOfSalesComponent: TermsOfSalesComponent,
    BackgroundVideo: BackgroundVideo
  }
};